export const create = {
  form: {
    code: '納入先 CD',
    name: '顧客名',
    type: 'タイプ',
    submit: '新規追加',
    select: 'セレクト',
    shortName: '顧客名(省略)',
    requireCode: '顧客コードを入力してください',
    requireName: '顧客名を入力してください',
    requireShortName: '顧客名(省略)を入力してください',
    requireType: '顧客タイプを入力してください',
    invalidLetters: '文字のみ入力できます。',
    invalidNumbers: '数字のみ入力できます。',
  },
  pageHeader: {
    title: '顧客リスト　新規追加画面',
    back: '戻る',
  },
}
